<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <div class="col-12 mt-2">
                    <ValidationProvider name="library_room_id" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('library_room_id')">
                            <LibraryRoomSelectbox :validateError="errors[0]" v-model="form.library_room_id" />
                        </b-form-group>
                    </ValidationProvider>
                </div>
                <div class="col-12 mt-2">
                    <ValidationProvider name="name" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('name')">
                            <b-form-input :state="errors[0] ? false : null" v-model="form.name">
                            </b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]">
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </div>
                <div class="col-12 mt-2">
                    <ValidationProvider name="status" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('status')">
                            <status-selectbox :validateError="errors[0]" v-model="form.status" />
                        </b-form-group>
                    </ValidationProvider>
                </div>
            </b-row>
        </ValidationObserver>
        <div class="col-12 mt-3 d-flex">
            <b-button @click="createForm" type="button" variant="primary" class="btn-lg mr-2" :disabled="formLoading">
                <b-spinner small v-if="formLoading"></b-spinner> {{ $t('save').toLocaleUpperCase('tr-TR') }}
            </b-button>
        </div>
    </div>
</template>

<script>
    import {ValidationProvider, ValidationObserver} from "vee-validate"
    import LibraryChairService from "@/services/LibraryChairService";
    import LibraryRoomSelectbox from "@/components/interactive-fields/LibraryRoomSelectbox";
    import StatusSelectbox from "@/components/interactive-fields/StatusSelectbox";

    export default {
        components: {
            ValidationProvider, ValidationObserver,
            LibraryRoomSelectbox, StatusSelectbox
        },
        data() {
            return {
                formLoading: false,
                form: {
                    library_room_id: null,
                    name: null,
                    status: 'a'
                }
            }
        },
        methods: {
            async createForm() {
                const isValid = await this.$refs.formModalValidate.validate()
                if (isValid) {
                    this.formLoading = true;
                    LibraryChairService.store(this.form)
                               .then((response) => {
                                   this.$toast.success(this.$t("api." + response.data.message));
                                   this.$emit("createFormSuccess")
                               })
                               .catch((error) => {
                                   this.showErrors(error, this.$refs.formModalValidate)
                               }).finally(() => {
                        this.formLoading = false;
                    });
                }
            }
        }
    }
</script>
